export default "__VITE_ASSET__e16LC4ZS__"